export type SmartphoneSaleConfigurations = {
  isAllowed: boolean
}

export const defaultSmartphoneSaleConfig: SmartphoneSaleConfigurations = {
  isAllowed: false,
}
